'use client';

import * as Sentry from '@sentry/nextjs';
import clsx from 'clsx';
import { FC, useEffect } from 'react';

import { HeaderBarSimple } from 'src/general/components/HeaderBarSimple/HeaderBarSimple';
import { arminFont } from 'src/general/helpers/fontsArmin';
import { carmaTitleFont } from 'src/general/helpers/fontsCarmaTitle';
import { WholePageMessage } from 'src/general/sections/WholePageMessage/WholePageMessage';
import { ErrorPageProps } from 'src/types/appRouter.types';

import './global.scss';
import './globals.css';

const GlobalError: FC<ErrorPageProps> = ({ error, reset }) => {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Global error', error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en" className={clsx(arminFont.variable, carmaTitleFont.variable)}>
      <body>
        <HeaderBarSimple />
        <WholePageMessage
          buttonLabel="Try again"
          buttonOnClick={reset}
          title="Oops, looks like something went wrong"
          iconSrc="/images/components/BadgeIllustration/carma-touch.svg"
          fullHeight
        />
      </body>
    </html>
  );
};

export default GlobalError;
